
import { IconAngleDown, IconAngleUp } from '../icons';
import './ToggleFilterButton.css';

const ToggleFilterButton = ({
	text,
	textSecondary,
	textTertiary,
	isOpen,
	onClick,
}) => {
	return (
		<button
			className={`toggle-filter-button ${isOpen ? 'active' : ''}`}
			onClick={onClick}
			aria-label="Toggle filter"
		>
			<span>
				{text}
				{!isOpen && textSecondary && (<><br/>{textSecondary}</>)}
				{!isOpen && textTertiary && (<><br/>{textTertiary}</>)}
			</span>
			{isOpen ? (<IconAngleUp />) : (<IconAngleDown />)}
		</button>
	);
}

export { ToggleFilterButton };